<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>规则设置</span>
        <el-button style="float: right;" type="primary" @click="setMembersBlackUser">保存</el-button>
      </div>
      <div class="setting">
        <el-switch class="li-switch" inactive-text="是否启用" v-model="open_status" active-color="#13ce66"
                   inactive-color="#ff4949" />
      </div>
      <div class="setting">
        <div class="setting-text">过去</div>
        <el-input class="setting-ipt" type="number" v-model="dayNum" placeholder="请输入内容"></el-input>
        <div class="setting-text">天内同一群订单数量超过</div>
        <el-input class="setting-ipt" type="number" v-model="validNum" placeholder="请输入内容"></el-input>
        <div class="setting-text">自动加黑</div>
      </div>
      <div class="setting">
        <el-switch class="li-switch" inactive-text="群黑名单用户自动加黑" v-model="add_black_user" active-color="#13ce66"
                   inactive-color="#ff4949" />
      </div>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>群黑名单</span> <span class="prompt">加入黑名单的群ID直接阻止下单</span>
      </div>

      <SpFilterForm :model="formData" @onSearch="onSearch" @onReset="onReset">
        <SpFilterFormItem prop="status" label="">
          <el-input v-model="formData.user_key" placeholder="请输入群ID" />
        </SpFilterFormItem>
      </SpFilterForm>
      <SpFinder no-selection ref="finder" :setting="setting" row-actions-width="250" :row-actions-align="'left'"
        :fixed-row-action="true" :url='url' :hooks="{
          beforeSearch: beforeSearch,
          afterSearch: afterSearch
        }" :split-count="5">
      </SpFinder>
    </el-card>
  </div>
</template>

<script>
import { createSetting } from '@shopex/finder'
import { getList, getMembersBlackUser, postMembersBlackUser, postMembersBlackUserUpdate } from './api'
import dayjs from 'dayjs'

const commonActions = [
  { label: '取消', key: 'close', size: 'default' },
  { label: '保存', key: 'save', type: 'primary', size: 'default' }
]

export default {
  components: {
  },
  data() {
    return {
      url: getList,
      setting: createSetting({
        columns: [
          { name: '群ID', key: 'user_key' },
          {
            name: '是否启用', key: 'status',
            render: (h, { row }) => {
              return <el-switch
                v-model={row.open_status}
                on-change={(value) => this.onStatusChange(row, value)}

                active-color="#13ce66"
                inactive-color="#ff4949">
              </el-switch>
            }
          },
          {
            name: '添加时间', key: 'created',
            render: (h, { row }) => {
              return <span>{dayjs(row.created * 1000).format('YYYY-MM-DD HH:mm:ss')}</span>
            }
          },
          {
            name: '', key: 'created',
            render: (h, { row }) => {
              return <span>{dayjs(row.created * 1000).format('YYYY-MM-DD HH:mm:ss')}</span>
            }
          },
        ],
        actions: [
          {
            name: '订单列表',
            key: 'to',
            type: 'button',
            buttonType: 'text',
            action: {
              handler: (row) => {
                console.log('aaaaaaaaaaaaaaaaaaaaa',row)
                this.$router.push({
                path: this.matchInternalRoute('/order/entitytrade/tradenormalorders'),
                query: {
                  groupNo: row[0].user_key,
                }
              })
              }
            }
          },
        ]
      }),
      formData: {
        user_key: '',
      },
      dayNum: '',
      validNum: '',
      open_status: true,
      add_black_user: false
    }
  },
  created() {
    this.membersBlackUser()
  },
  methods: {
    membersBlackUser() {
      getMembersBlackUser({ user_type: 'group' }).then(res => {
        const { open_status, day_num, valid_num, add_black_user } = res.data.data
        this.open_status = open_status
        this.dayNum = day_num
        this.validNum = valid_num
        this.add_black_user = add_black_user
      })
    },
    setMembersBlackUser() {
      const params = {
        user_type: 'group',
        open_status: this.open_status,
        day_num: this.dayNum,
        valid_num: this.validNum,
        add_black_user: this.add_black_user
      }
      postMembersBlackUser(params).then(res => {
        // 提示保存成功
        this.$message({
          message: '保存成功',
          type: 'success'
        });
      })
    },
    // 状态改变
    onStatusChange(row, v) {
      postMembersBlackUserUpdate({ id: row.id, open_status: v }).then(res => {
      })
    },
    beforeSearch(params) {
      const { user_key } = this.formData
      const data = {
        ...params,
        user_key,
        user_type: 'group',
      }
      return data
    },
    afterSearch(res) {
      const { data } = res.data
      return data
    },

    onSearch() {
      this.$refs.finder.refresh(true)
    },
    onReset() {
      this.formData = {
        user_key: ''
      }
      this.$refs.finder.refresh(true)
    },
  }
}
</script>

<style lang="scss" scoped>
.setting {
  display: flex;
  align-items: center;

  .setting-text {
    height: 21px;
  }

  .setting-ipt {
    width: 125px;
  }
}

.prompt{
  font-size: 12px;
  color: #999;
  margin-left: 10px;
}

.sp-finder-hd {
  padding-top: 10px !important;
}

.view-template-dialog {
  .sp-finder-hd {
    display: none;
  }

  .el-dialog__body {
    padding: 0 !important;

    .el-form {
      margin: 0 !important;
    }

    .el-form-item {
      margin-bottom: 0 !important;
    }
  }
}
</style>
